import { render, staticRenderFns } from "./USIndustryPanel.vue?vue&type=template&id=3e9f8851&scoped=true"
import script from "./USIndustryPanel.vue?vue&type=script&lang=js"
export * from "./USIndustryPanel.vue?vue&type=script&lang=js"
import style0 from "./USIndustryPanel.vue?vue&type=style&index=0&id=3e9f8851&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e9f8851",
  null
  
)

export default component.exports